import React, { useContext, useEffect } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios";
import '../Login/Login.scss';
import MyContext from "../Context/MyContext";
import { useNavigate } from "react-router-dom";

const Register = () => {

  const Navigate = useNavigate()

  useEffect(()=>{
    sessionStorage.getItem('token') && Navigate('/')
},[])

  const{setLoader,setOpen,setMessage,url} = useContext(MyContext)
  // Validation schema
  const validationSchema = Yup.object().shape({
    name: Yup.string()
      .min(3, "Name must be at least 3 characters")
      .required("Full name is required"),
    email: Yup.string()
      .email("Invalid email format")
      .required("Email is required"),
    password: Yup.string()
      .min(6, "Password must be at least 6 characters")
      .required("Password is required"),
    confirmpassword: Yup.string()
      .oneOf([Yup.ref("password"), null], "Passwords must match")
      .required("Confirm password is required"),
  });

  // Initial values
  const initialValues = {
    name: "",
    email: "",
    password: "",
    confirmpassword: "",
  };

  // Form submission handler
  const handleSubmit = async (values,{resetForm}) => {
    setLoader(true)
  
    document.querySelector('body').style.overflow='hidden'
    try {
      const {data} = await axios.post(`${url}/register`,values);
    
      if(data.success){
      setMessage(data.message);
      setOpen(true)
      resetForm()
      Navigate('/login')

      }else{
        setMessage(data.error)
        setOpen(true)
      }
    } catch (error) {
      console.error("Error during registration", error);
      alert("Registration failed. Please try again.");
    }finally{
      setLoader(false)
      
       document.querySelector('body').style.overflow='auto'
    }
  };

  return (
    <div className="login-container">

    <h1 className="head">Vemox</h1>
      <h1 className="headl">Register Here</h1>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {() => (
          <Form className="form">
            <div className="form-group">
              <label htmlFor="name" className="form-label">
                FullName:
              </label>
              <Field
                type="text"
                id="name"
                name="name"
                className="form-input"
                placeholder="Enter your name"
              />
              <ErrorMessage name="name" component="div" className="form-error" />
            </div>
            <div className="form-group">
              <label htmlFor="email" className="form-label">
                Email:
              </label>
              <Field
                type="email"
                id="email"
                name="email"
                className="form-input"
                placeholder="Enter your email"
              />
              <ErrorMessage name="email" component="div" className="form-error" />
            </div>
            <div className="form-group">
              <label htmlFor="password" className="form-label">
                Password:
              </label>
              <Field
                type="password"
                id="password"
                name="password"
                className="form-input"
                placeholder="Enter your password"
              />
              <ErrorMessage
                name="password"
                component="div"
                className="form-error"
              />
            </div>
            <div className="form-group">
              <label htmlFor="confirmpassword" className="form-label">
                Confirm Password:
              </label>
              <Field
                type="password"
                id="confirmpassword"
                name="confirmpassword"
                className="form-input"
                placeholder="Confirm your password"
              />
              <ErrorMessage
                name="confirmpassword"
                component="div"
                className="form-error"
              />
            </div>

            <button type="submit" className="btn btn-primary">
              Register
            </button>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default Register;
